/**
 * PromoteIcon/index.js
 * desc: promote icon
 * note: action icon via IconButton; defaults its tooltip + accessible name to the
 *       action label. Renders an accessible button when given an onClick handler.
 */
'use strict';

import IconButton from '../IconButton';
import { translate } from '../../../utilities/localization';


const PromoteIcon = ({ tooltip, ...props }) => (
    <IconButton
        baseClassName="promote icon"
        // accessible name follows the tooltip override so the visible tip + aria-label always match
        label={ tooltip || translate('icons.promote.tooltip.text') }
        tooltip={ tooltip }
        { ...props }
    >
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M23.9728 0.898855L17.5373 23.4868C17.3821 24.0305 16.632 24.2242 16.2558 23.6597L12.0093 17.8351L9.73284 21.2234C9.50468 21.5629 8.97229 21.3546 9.03481 20.9515L9.94746 15.0061L15.1827 10.3075C15.9641 9.60546 14.8973 8.41594 14.1138 9.12008L8.44007 14.2114L0.409668 10.544C-0.152932 10.2867 -0.128955 9.48154 0.437798 9.25239L0.436756 9.25031L23.0301 0.053111C23.5802 -0.17083 24.129 0.352015 23.9728 0.898855Z"/>
        </svg>
    </IconButton>
);


export default PromoteIcon;
